export default "__VITE_ASSET__DilWvpuP__"